import React from "react";
import TransferList from "./TransferList";

/**
 * Twee kolommen met toegekende en beschikbare rollen; verplaatsen door te slepen, met de pijltjesknop of met een
 * dubbele klik. Zie TransferList voor de eigenschappen.
 */
export default function RolePicker({ roles, value, initial, onChange, disabled }) {
  return (
    <TransferList
      items={roles}
      value={value}
      initial={initial}
      onChange={onChange}
      disabled={disabled}
      noun="Rol"
      plural="rollen"
      bulk
      parentOf={(role) => role.parent_role_id || null}
      isPrimary={(role) => !!role.is_primary}
      metaOf={(role) => (role.permission_count !== undefined ? `${role.permission_count} rechten` : "")}
    />
  );
}
